// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-defc4f42]{font-size:1.3rem}", "",{"version":3,"sources":["webpack://src/components/maps/SearchBar.vue"],"names":[],"mappings":"AACA,wBACE,gBAAA","sourcesContent":["\n.title\n  font-size: 1.3rem\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
